module.exports = __webpack_public_path__ + "static/img/有問題隨時問_300×300.b9f5f2c2.png";